const {MerchantSelect} = require("../../../../../dumb/FormInputs");
const BtnAdd = require("../BtnAdd");
const React = require("react");

module.exports = ({selectProps, btnProps}) => (
  <div className="layoutRow fhaS aiFE">
    <div className="rlv fx1 wmin0">
      <MerchantSelect {...selectProps} />
    </div>
    <BtnAdd
      {...btnProps}
    />
  </div>
)
